import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { map, Observable, ReplaySubject, tap } from "rxjs";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { HotkeyDirective } from "~app/common/directives/hotkey/hotkey.directive";
import { AnvandareDTO } from "~app/common/models/anvandare/AnvandareDTO";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { ApiClientService } from "~app/common/services/api-client.service";
import { RaskCommonModule } from "../../../../common/rask-common.module";
import { AnvandareVikarieDto } from "../models/anvandareVikarieDto";

type AssignVikarieFormGroup = FormGroup<{
    franDatum: FormControl<string>;
    tillDatum: FormControl<string>;
    anvandare: FormControl<AnvandareDTO>;
    vikarie: FormControl<AnvandareDTO>;
}>;

@Component({
    imports: [
        ReactiveFormsModule,
        RaskCommonModule,
        DatepickerComponent,
        ButtonComponent,
        HotkeyDirective
    ],
    templateUrl: "./vikariehantering-modal.component.html",
    styleUrl: "./vikariehantering-modal.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager
})
export class VikariehanteringModalComponent {
    set virkeskopare(val: AnvandareVikarieDto) {
        this.virkeskopareSrc.next(val ?? {});
    }

    protected form: AssignVikarieFormGroup = new FormGroup({
        franDatum: new FormControl(""),
        tillDatum: new FormControl(""),
        anvandare: new FormControl(null),
        vikarie: new FormControl(null)
    });

    protected virkeskopare$: Observable<AnvandareVikarieDto>;
    private readonly modal = inject(NgbActiveModal);

    private readonly virkeskopareSrc = new ReplaySubject<AnvandareVikarieDto>(1);

    private readonly apiClientService = inject(ApiClientService);

    constructor() {
        this.virkeskopare$ = this.virkeskopareSrc.pipe(
            tap(v => this.form.patchValue({
                ...v
            }))
        );
    }

    protected cancel() {
        this.modal.close();
    }

    protected searchAnvandareTypeAhead = (input: string) =>
        this.apiClientService.post<any, ITypeAheadResult[]>("typeahead/anvandare", { query: input,
            addUserUserNameToName: true }, false, null, ApiClientService.JsonHeader).pipe(
            map(result => result.map<AnvandareDTO>(x => ({
                namn: x.namn,
                userName: x.kod,
                id: x.id,
                efternamn: "",
                fornamn: "",
                rowVersion: "",
                userId: ""
            })))
        );

    protected searchForAnsvarigPlanerareTypeAhead = (input: string) =>
        this.apiClientService.get<ITypeAheadResult[]>(`typeahead/anvandare/virkeskopa?input=${input}`).pipe(
            map(result => result.map<AnvandareDTO>(x => ({
                namn: x.namn,
                userName: x.kod,
                id: x.id,
                efternamn: "",
                fornamn: "",
                rowVersion: "",
                userId: ""
            })))
        );

    protected save(virkeskopare: AnvandareVikarieDto) {
        const result: AnvandareVikarieDto = {
            ...virkeskopare,
            ...this.form.value
        };

        this.modal.close(result);
    }
}
